import React, { Fragment } from 'react'
import { makeStyles, CircularProgress, Typography } from '@material-ui/core'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { EditIcon } from '../../../../../Assets/Images/icons/editIcon'
import { roleLabel } from '../../../UsersListTable'
import { styles } from './styles'
import { ROLE_CLIENT, ROLE_CLIENT_ADMIN } from '../../../../../shared/constants'
import classNames from 'classnames'

const useStyles = makeStyles(() => styles)

export const ProfileInfo = ({ user }) => {
  const match = useRouteMatch()
  const history = useHistory()
  const classes = useStyles()
  const loading = !Object.values(user).length

  return loading ? (
    <div className={classes.loadingContainer}>
      <CircularProgress />
    </div>
  ) : (
    <Fragment>
      <div
        className={classNames(
          classes.infoContainer,
          'makeStyles-infoContainer',
        )}
      >
        <div
          className={classNames(classes.imageColumn, 'makeStyles-imageColumn')}
        >
          <img
            className={classNames(classes.image, 'makeStyles-image')}
            src={user.profilePicture}
            alt="profile"
            cypress_id={'userAvatar'}
          />
        </div>
        <div className={classes.info}>
          <div className={classNames(classes.row, 'makeStyles-row')}>
            <div
              className={classNames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <Typography className={classes.userName} cypress_id={'userName'}>
                {user.firstName} {user.lastName}
              </Typography>
              <Typography className={classes.value} cypress_id={'userRole'}>
                {roleLabel[user.role]}
              </Typography>
            </div>
          </div>

          <div className={classNames(classes.row, 'makeStyles-row')}>
            {[ROLE_CLIENT_ADMIN, ROLE_CLIENT].includes(user.role) ? null : (
              <div
                className={classNames(classes.infoItem, 'makeStyles-infoItem')}
              >
                <Typography className={classes.infoItemTitle}>
                  Country
                </Typography>
                <Typography className={classes.value}>
                  {user.countryName}
                </Typography>
              </div>
            )}

            <div
              className={classNames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <Typography
                className={classes.infoItemTitle}
                cypress_id={'companyTitle'}
              >
                Company
              </Typography>
              <Typography className={classes.value} cypress_id={'companyName'}>
                {(user.client && user.client.name) || '-'}
              </Typography>
            </div>
            <div
              className={classNames(classes.infoItem, 'makeStyles-infoItem')}
            />
          </div>

          <div className={classNames(classes.row, 'makeStyles-row')}>
            <div
              className={classNames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <Typography
                className={classes.infoItemTitle}
                cypress_id={'emailTitle'}
              >
                Email address
              </Typography>
              <Typography className={classes.value} cypress_id={'userEmail'}>
                {user.email}
              </Typography>
            </div>
            <div
              className={classNames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <Typography
                className={classes.infoItemTitle}
                cypress_id={'businessPhoneNumberTitle'}
              >
                Business phone number
              </Typography>
              <Typography
                className={classes.value}
                cypress_id={'userBusinessPhoneNumber'}
              >
                {user.mobilePhone}
              </Typography>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.buttonsContainer}>
        <button
          className={classes.profileButton}
          onClick={() => {
            history.push(`${match.url}/edit`)
          }}
          variant="outlined"
          cypress_id={'profileBtn'}
        >
          <EditIcon />
          <span className={classes.editButtonLabel} cypress_id={'editBtn'}>
            Edit
          </span>
        </button>
      </div>
    </Fragment>
  )
}
